import { List } from './styles'

const Component = ({children, ...rest}:any) =>{
  return <List {...rest}>{children}</List>
}

export default Component
